import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import pageNotFound from '../../assets/images/404.svg';
import { Translate } from '../../shared/LanguageService';

type PageNotFoundProps = {
    title: string;
    description: string;
};

function Spacer() {
    return <Box sx={{ minWidth: '1px', maxWidth: '1px', minHeight: '16px', maxHeight: '16px' }} />;
}

function PageNotFound({ title, description }: PageNotFoundProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                paddingTop: '100px'
            }}
        >
            <img src={pageNotFound} />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: '60px',
                    minWidth: '394px'
                }}
            >
                <Typography
                    variant="h1"
                    sx={({ palette }) => ({
                        fontFamily: 'Gilroy',
                        fontWeight: 700,
                        fontSize: '40px',
                        color: palette.secondary.dark
                    })}
                >
                    {title}
                </Typography>
                <Spacer />
                <Typography
                    variant="h2"
                    sx={({ palette }) => ({
                        fontFamily: 'Gilroy',
                        fontWeight: 600,
                        fontSize: '32px',
                        color: palette.primary.light
                    })}
                >
                    {description}
                </Typography>
            </Box>
        </Box>
    );
}

export default function TranslatedPageNotFound() {
    let title = Translate('404-error/title');
    let description = Translate('404-error/description');

    return <PageNotFound title={title} description={description} />;
}
